var otherSourcesRequest = axios.create({
  baseURL: '/api/othersources'
});

/** Thingnario 來源帳號與各自的 API 配額 */
export var getThingnarioAccountsApi = function getThingnarioAccountsApi() {
  return otherSourcesRequest.post('/thingnario/accounts').then(function (res) {
    return res.data;
  });
};

/**
 * Thingnario 全電廠總覽：今日發電、PR、日照曲線、進行中告警
 * @param {string} [accountId] 只看單一來源帳號時給
 */
export var getThingnarioOverviewApi = function getThingnarioOverviewApi(accountId) {
  return otherSourcesRequest.post('/thingnario/overview', {
    accountId: accountId
  }).then(function (res) {
    return res.data;
  });
};

/**
 * 單一電廠的逆變器昨日 PR 比較（展開卡片才呼叫，會多吃一次 API 配額）
 * @param {string} accountId
 * @param {string} plantNo
 */
export var getThingnarioPlantInvertersApi = function getThingnarioPlantInvertersApi(accountId, plantNo) {
  return otherSourcesRequest.post('/thingnario/plantInverters', {
    accountId: accountId,
    plantNo: plantNo
  }).then(function (res) {
    return res.data;
  });
};

/**
 * 歷史告警（已結束的事件）
 * @param {object} params { accountId, start: '2026-08-15', end: '2026-08-21' }
 */
export var getThingnarioEventsApi = function getThingnarioEventsApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return otherSourcesRequest.post('/thingnario/events', params).then(function (res) {
    return res.data;
  });
};

/**
 * SolarEdge 全案場總覽：今日發電、即時發電功率、等效小時、今日發電功率曲線
 * 沒有帳號參數 —— 一把金鑰，`account` 恆為 null
 */
export var getSolarEdgeOverviewApi = function getSolarEdgeOverviewApi() {
  return otherSourcesRequest.post('/solaredge/overview').then(function (res) {
    return res.data;
  });
};

/**
 * 單一案場的逐台逆變器比較（展開卡片才呼叫）
 * @param {string} plantNo SolarEdge siteId
 */
export var getSolarEdgePlantInvertersApi = function getSolarEdgePlantInvertersApi(plantNo) {
  return otherSourcesRequest.post('/solaredge/plantInverters', {
    plantNo: plantNo
  }).then(function (res) {
    return res.data;
  });
};

/**
 * SmartPVMS（華為）全案場總覽：今日發電、即時發電功率、等效小時、PR、逐台狀態
 * 沒有帳號參數 —— 一組帳密，`account` 恆為 null
 */
export var getSmartPVMSOverviewApi = function getSmartPVMSOverviewApi() {
  return otherSourcesRequest.post('/smartpvms/overview').then(function (res) {
    return res.data;
  });
};

/**
 * 單一案場的逐台逆變器比較（展開卡片才呼叫）
 * @param {string} plantNo 華為 plantCode，例如 'NE=78119810'
 */
export var getSmartPVMSPlantInvertersApi = function getSmartPVMSPlantInvertersApi(plantNo) {
  return otherSourcesRequest.post('/smartpvms/plantInverters', {
    plantNo: plantNo
  }).then(function (res) {
    return res.data;
  });
};

/**
 * AUO 友達全案場總覽：今日發電、電表對照、即時發電功率、等效小時、PR
 * 沒有帳號參數 —— 一把金鑰一座案場
 */
export var getAUOOverviewApi = function getAUOOverviewApi() {
  return otherSourcesRequest.post('/auo/overview').then(function (res) {
    return res.data;
  });
};

/**
 * 單一案場的逐台逆變器比較與告警明細（展開卡片才呼叫）
 * @param {string} plantNo AUO plantNo，例如 'BDL021030231'
 */
export var getAUOPlantInvertersApi = function getAUOPlantInvertersApi(plantNo) {
  return otherSourcesRequest.post('/auo/plantInverters', {
    plantNo: plantNo
  }).then(function (res) {
    return res.data;
  });
};

// -------------------------------------------------------------
// -------- 每分鐘資料下載（讀 BigQuery api_min，四家共用）--------
// -------------------------------------------------------------

/**
 * 下載頁的選項：這個來源有哪些案場、各有哪些裝置（只列近 30 天真的有資料的）
 * @param {string} provider 'thingnario' | 'solaredge' | 'smartpvms' | 'auo'
 * @returns {Promise<{data: {plants: object[], maxDays: number}}>}
 */
export var getApiMinOptionsApi = function getApiMinOptionsApi(provider) {
  return otherSourcesRequest.post('/download/options', {
    provider: provider
  }).then(function (res) {
    return res.data;
  });
};

/**
 * 下載每分鐘資料 xlsx。後端直接把檔案串回來，所以 responseType 是 blob
 * @param {object} body { provider, plantNo, from, to, devices, realOnly }
 */
export var downloadApiMinApi = function downloadApiMinApi(body) {
  return otherSourcesRequest.post('/download/xlsx', body, {
    responseType: 'blob'
  });
};